const buttonTextTermsOfServicePrivacyStyles = {
  termsOfServiceText: {
    fontSize: 12,
    textAlign: "center",
    marginTop: "10px",
  },
};

export default buttonTextTermsOfServicePrivacyStyles;
